import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { debugOutputAstAsTypeScript } from '@angular/compiler';
@Injectable()
export class DataService {

  private applicantSource = new BehaviorSubject<FormArray>(null);
  currentAddAnotherApplicant = this.applicantSource.asObservable();
 
  formApplicant: FormArray;
  constructor(
    public formBuilder: FormBuilder
  ) { 
    this.formApplicant = new FormArray([])
    // this.addAnotherApplicantItem = new FormGroup({
    //     items: this.items
    // });
    
  }
  initaddAnotherApplicant() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      secondary_firstname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: ['', Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: ['', Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['Life Partner', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }
  
  changeaddanotherApplicant() {
     
    this.formApplicant.push(this.initaddAnotherApplicant());
    this.applicantSource.next(this.formApplicant);
  }

}


// WEBPACK FOOTER //
// ./src/pages/adf-page/services/data.service.ts